import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { endpointsURL } from "../constants/endpointsURL";
import {
  DetailFsPlaca,
  FsplacaListMapped,
  FsplacaPK,
} from "./models/fsplaca.model";
import { map } from "rxjs/operators";
import { ResponsesPageablesTyped } from "../core/models/responesPageables";

@Injectable({
  providedIn: "root",
})
export class FsplacaService {
  env = environment.env;
  fsplacaURL = endpointsURL.fsplacaURL;

  constructor(private httpClient: HttpClient) {}

  public list(
    filters?: string
  ): Observable<ResponsesPageablesTyped<FsplacaListMapped>> {
    return this.httpClient
      .get<any[]>(`${this.env}${this.fsplacaURL}list${filters}`)
      .pipe(
        map((response) => {
          return this.mapList(response);
        })
      );
  }

  private mapList(response: any): ResponsesPageablesTyped<FsplacaListMapped> {
    response.content.forEach((e) => {
      e.fsPlacmye = e.id.fsPlacmye;
      e.fsPlaccor = e.id.fsPlaccor;
      e.fsPlacimg = e.id.fsPlacimg.substring(3);
      e.fsPlaclib1 = e.id.fsPlaclib1;
      e.fsPlacmod = e.id.fsPlacmod;
      e.fsPlacprs = e.fsPlacprs.trim();
    });
    return response;
  }

  public getFsPlaca(dtoPK: FsplacaPK): Observable<DetailFsPlaca> {
    let params = new HttpParams();
    params = params.append("dtoPK", JSON.stringify(dtoPK));
    return this.httpClient.get<DetailFsPlaca>(
      `${this.env}${this.fsplacaURL}detail`,
      {
        params: params,
      }
    );
  }
}
